import React from 'react'
import './School.css';

const School = () => {
  return (
    <div>
        {/* <h1 className='school_header'>About us</h1> */}
        <div className='school_main_container'>
        <div>
         <img className='school_img' src="./img1.jpg" alt="" />
        </div>
        <div className='school_paragraph'>
            <p> Sai Shanti Vidya Niketan is dedicated to providing an exceptional early childhood education experience for our youngest learners. With programs specially designed for pre-nursery, nursery, LKG, and UKG, we aim to create a joyful, engaging, and nurturing environment that fosters the holistic development of every child.
             we strive to lay the foundation for a lifelong love of learning. Join us in our mission to nurture young minds and help them reach their full potential. The school’s mission is to create a joyful, engaging, and nurturing environment for children in their formative years.
              By focusing on holistic development, the institution aims to lay a strong foundation for a lifelong love of learning.
            </p>
        </div>

       
        </div>

<h1 className='school_header'>Mission</h1>
<div className='school_main_container'>
      
      <div className='school_paragraph'>
          <p> At Sai Shanti Vidya Niketan, our mission is to provide a high-quality early childhood education that lays the groundwork for lifelong learning and success.
          To rise the best infrastructure, to partner with the best heads & to offer the best possible ambience. 
          We are committed to nurturing young minds by creating an environment that fosters curiosity, creativity, and a love for learning.We are dedicated to providing an exceptional educational experience through superior infrastructure, collaboration with experienced educators, and a nurturing environment that fosters curiosity, creativity, and a passion for learning.
          </p>
      </div>

      <div>
       <img className='school_img' src="./img2.jpg" alt="" />
      </div>
      </div>

      <h1 className='school_header'>Vision</h1>
        <div className='school_main_container'>
        <div>
         <img className='school_img'   src="./img3.jpg" alt="" />
        </div>
        <div className='school_paragraph' >
            <p>At Sai Shanti Vidya Niketan our vision is to create a nurturing and stimulating environment where young minds are encouraged to explore, learn, and grow.
            To be among the best in imparting education right from early knowledge centre to research power house.We aspire to be a beacon of excellence in early childhood education, fostering the holistic development of our students and laying a strong foundation for their future academic and personal success.
            We aspire to be a leading institution in early childhood education, progressing from a foundational knowledge center to a beacon of educational excellence. Our aim is to foster the holistic development of each student and lay a robust foundation for their future academic and personal achievements.
            </p>
        </div>





       
        </div>

        <h1 className='school_header'>Health</h1>
        <div className='school_main_container'>
       
        <div className='school_paragraph'>
            <p> At our school, we prioritize the health and well-being of our students. We provide free medical check-ups for all children once every three months, ensuring they are healthy and thriving. Regular health assessments help us monitor their growth and development, address any concerns early on, and promote a healthy lifestyle from a young age.
            To ensure our students' physical health and overall well-being, we have implemented several key initiatives and practices.
            We are committed to fostering a healthy environment where every child can thrive physically, emotionally, and socially. Our proactive approach to health ensures that students receive comprehensive care and support throughout their time at our school.
            </p>
        </div>
        <div>
         <img className='school_img' src="./health.jpg" alt="" />
        </div>

       
        </div>

        <div className='class_event'>
        <h1 className='class_header_schools'>Events</h1>
        <div className='class_events_maneger'>
<div className='resource_paragraph'>
  <h4>Independence Day</h4>
  <p className='class_paragraph_school'>Independence Day is celebrated with great enthusiasm at our school. Children participate in flag hoisting, 
    sing patriotic songs, and perform skits, instilling a sense of national pride and understanding of our country’s
     history.</p>
  <h4>Republic Day</h4>
  <p className='class_paragraph_school'>On Republic Day, our students enjoy a colorful parade, engaging in cultural performances and activities 
    that highlight the importance of our constitution and democratic values.</p>
  <h4>Gandhi Jayanti</h4>
  <p className='class_paragraph_school'>Gandhi Jayanti is a special day where we honor the legacy of Mahatma Gandhi. Children learn about his life and values through storytelling,
     role plays, and activities that promote peace and non-violence.</p>
  <h4>Children's Day</h4>
  <p className='class_paragraph_school'>Children’s Day is a fun-filled day dedicated to celebrating the joy of childhood. Our school organizes games, performances, 
    and special treats, making it a memorable experience for every child.</p>
  <h4>Teacher's Day</h4>
  <p className='class_paragraph_school'>Teacher’s Day is a heartfelt occasion where students express their gratitude and appreciation for their teachers. The day is marked by special assemblies, student performances, 
    and activities that celebrate the bond between teachers and students.</p>
</div>
        </div>

        <h1 className='class_header_schools'>Other Events</h1>
        <div className='class_Otherevents_maneger'>
<div className='resource_paragraph'>
  <h4>Ganesha Puja</h4>
  <p className='class_paragraph_school'>At our school, we celebrate Ganesha Puja with devotion and joy. This auspicious event introduces children to cultural traditions, fostering a sense of reverence and 
    community as they partake in prayers and festivities honoring Lord Ganesha.</p>
  <h4>Saraswati Puja</h4>
  <p className='class_paragraph_school'>Saraswati Puja is a special occasion where we pay homage to the Goddess of Knowledge. Through this celebration, children learn to appreciate the importance of education and the arts,
     engaging in activities that highlight the significance of wisdom and learning.</p>
  <h4>Holi</h4>
  <p className='class_paragraph_school'>Our Holi celebration is a vibrant and joyful event where children experience the festival of colors. Through playful activities and storytelling, they learn about the cultural
     and historical significance of Holi, embracing its spirit of unity and happiness.</p>
  <h4>Annual Function</h4>
  <p className='class_paragraph_school'>The Annual Function is a showcase of our students' talents and achievements. This grand event features performances, exhibitions, and awards, providing a platform for children to express 
    their creativity and celebrate their accomplishments with family and friends.</p>
  <h4>Annual Sports</h4>
  <p className='class_paragraph_school'>Annual Sports Day is a highlight of our school year, promoting physical fitness and teamwork. Children participate in a variety of fun and competitive sports activities,
     learning the values of discipline, perseverance, and sportsmanship</p>
</div>
        </div>
        </div>



 
    </div>
  )
}

export default School